import {Button} from 'antd'
import {course_getCourses_Api,} from 'apis'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsCloudDownload, BsCloudUpload} from 'react-icons/bs'
import {PiCertificate} from 'react-icons/pi'
import {TbCertificate, TbCertificateOff, TbSum} from 'react-icons/tb'
import {RiSubscript} from 'react-icons/ri'
import {useLocation} from 'react-router-dom'
import {course_status_options, CourseActionTypes,} from 'views/AppLocals/Course'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CourseFilter from '../components/filters/CourseFilter'
import {FaAward, FaUserGraduate} from "react-icons/fa6";
import {copyLocationParam, getRouteSearchParams, useRouteSearchParam} from "../../../../envs/_current/history";
import {MdOutlineControlPointDuplicate} from "react-icons/md";
import {LuArrowRightLeft} from "react-icons/lu";
import {SectionTemplate} from "../../Workspace";
import {CourseContainerContext} from "./CourseContainer";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {useCourseForm} from "../../../AppLocals/Course/CourseClass/useCourseForm";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {ClassroomSvg} from "../../../../components/Svgs/ClassroomSvg";
import {CourseStates} from "../WorkspaceCourse";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Courses = ({
                     owner_id,
                     owner_type,
                     filter_actions = {
                         sortBy: 'sort-by',
                         keyword: 'keyword',
                         status: 'course-status',
                         academic_year: 'academic-year',
                         academic_field: 'academic-field'
                     },
                 }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)

    const [refreshKey, setRefreshKey] = useState()

    const {onChangeSearchParams} = useRouterSearchParam({})
    const {onSelectCourseContainerRoute, setCurrentCourseId} = useContext(CourseContainerContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)
    const academic_year = useRouteSearchParam(filter_actions.academic_year) || ""
    const academic_field = useRouteSearchParam(filter_actions.academic_field) || ""

    let timeout
    useEffect(() => {
        const searchParams = getRouteSearchParams()
        searchParams.set(filter_actions.status, course_status_options.normal.value)
        timeout = setTimeout(() => {
            history.replace({
                ...copyLocationParam(window.location ?? {}),
                search: '?' + searchParams.toString(),
            })
        })
        return () => clearTimeout(timeout)
    }, [])


    const {
        modal, modalIO,
        handleAction,
        onCancel,
        refreshKey: refreshKeyFromForm
    } = useCourseForm({owner_id, owner_type})

    useEffect(() => {
        setRefreshKey(refreshKeyFromForm)
    }, [refreshKeyFromForm])

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <MdOutlineControlPointDuplicate size={14} className="text-green-500"/>,
                        label: 'duplicate',
                        key: CourseActionTypes.COURSE_COPY,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CourseActionTypes.COURSE_UPDATE,
                    },
                    {
                        icon: <RiSubscript size={14} className="text-color-200"/>,
                        label: 'subjects of course',
                        key: CourseActionTypes.SHOW_SUBJECT_LIST_MODAL,
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <LuArrowRightLeft size={14} className="text-green-500"/>,
                        label: 'import / export data',
                        children: [
                            {
                                key: "COURSE_STUDENT_IMPORT",
                                label: 'import student data',
                                icon: <BsCloudUpload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_STUDENT_EXPORT",
                                label: 'export student data',
                                icon: <BsCloudDownload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_ATTENDANCE_IMPORT",
                                label: 'import attendance data',
                                icon: <BsCloudUpload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_ATTENDANCE_EXPORT",
                                label: 'export attendance data',
                                icon: <BsCloudDownload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_GRADE_IMPORT",
                                label: 'import grade data',
                                icon: <BsCloudUpload size={14} className="text-color-300"/>,
                            },
                            {
                                key: "COURSE_GRADE_EXPORT",
                                label: 'export grade data',
                                icon: <BsCloudDownload size={14} className="text-color-300"/>,
                            },
                        ],
                    },
                    {
                        icon: <PiCertificate size={14} className="text-green-500"/>,
                        label: 'certification',
                        disabled: !!!item?.medal,
                        children: [
                            {
                                key: "COURSE_MEDAL_GRANT_TO_ALL_STUDENTS",
                                label: 'grant to all students',
                                icon: <TbCertificate size={14} className="text-green-600"/>,
                                disabled: !!!item?.medal,
                            },
                            {
                                key: "COURSE_MEDAL_REVOKE_ALL_TO_STUDENTS",
                                label: 'revoke all from students',
                                icon: <TbCertificateOff size={14} className="text-red-600"/>,
                                disabled: !!!item?.medal,
                            },
                            {
                                key: "COURSE_MEDAL_ISSUE_IF_ELIGIBLE",
                                label: 'issue 3rd certificate',
                                icon: <FaAward size={14} className="text-color-300"/>,
                                disabled: !!!item?.medal,
                            }
                        ],
                    },
                    {
                        icon: <TbSum size={14} className="text-primary"/>,
                        label: 'update final results',
                        key: CourseActionTypes.COURSE_UPDATE_RESULT_ALL,
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CourseActionTypes.COURSE_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
                academic_year,
                academic_field
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderCourse({
                t,
                onSelectCourseContainerRoute,
                renderContextMenu
            }),
            PaginationMeta: renderGridMeta,
            apiInfo: course_getCourses_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: false,
        query_params: filter_actions,
        AdvancedFilter: CourseFilter,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })


    return (
        <div className="flex flex-1 flex-col space-y-3">
            <SectionTemplate
                title={t("course management")}
                description={t("this is the course library used to build content for courses. manage documents, sample lectures, and assessment standards.")}
                actionText={t("create course")}
                renderActionButton={() => (
                    <Button
                        type="primary"
                        className="mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-600 transition"
                        onClick={() => {
                            handleAction(CourseActionTypes.COURSE_CREATE)
                        }}>
                        + {t('create course')}
                    </Button>
                )}
            />
            {pager_widget}
            {modal}
            {!!modalIO ? modalIO : null}
        </div>
    )
}


const renderCourse = ({onSelectCourseContainerRoute, t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {

    const CourseStatesBorder = [
        {
            value: 'enrollment_open',
            className: 'border-green-600',
        },
        {
            value: 'in_process',
            className: 'border-blue-600',
        },
        {
            value: 'completed',
            className: 'border-primary-600',
        },
    ]

    const {
        time_open,
        course_state,
        course_class_count,
        student_count,
        academic_field,
        academic_year
    } = item ?? {}

    return (
        <div
            key={item.id}
            style={{
                borderTop: '1px solid var(--border-color-50)',
                borderRight: '1px solid var(--border-color-50)',
                borderBottom: '1px solid var(--border-color-50)',
            }}
            className={classNames(
                "p-3 border-l-4 shadow-md rounded-lg hover:scale-xs custom-item-render relative",
                _.find(CourseStatesBorder, {value: course_state})?.className
            )}>
            <h2
                onClick={() => {
                    onSelectCourseContainerRoute({current_course_id: item.id})
                }}
                className="font-bold text-lg text-color-000 hover:text-primary cursor-pointer">
                {item.title}
            </h2>
            <div className="flex items-center gap-1 text-sm">
                <span className="text-color-400 italic">
                    {`${t("start")}: `}
                </span>
                <span className="font-medium text-color-200 tracking-wide">
                    {formatSimplifyDate(time_open, null, "DD/MM/YYYY")}
                </span>
            </div>
            <div className="mt-2 pt-3 border-t border-color-100 flex flex-col gap-1">
                {(academic_field !== null || academic_year !== 0) && (
                    <div
                        style={{ padding: '3px 8px', fontSize: 11, borderRadius: 999, wordBreak: 'break-all' }}
                        className="w-fit border border-primary-400 font-medium text-primary-700 italic leading-tight min-w-0 max-lines-1">
                        {academic_field} {(academic_year !== 0 && academic_field !== null) ? ` - ${academic_year}` : academic_year !== 0 ? academic_year : ''}
                    </div>
                )}
                <div className="mt-1 flex justify-between text-sm">
                    <div className="flex flex-col gap-1">
                        <div className="flex items-center font-medium text-color-100">
                            <ClassroomSvg size={14} className="mr-2 text-color-400"/>
                            {`${course_class_count} ${t('classes')}`}
                        </div>
                        <div className="flex items-center font-medium text-color-100">
                            <FaUserGraduate size={14} className="mr-2 text-color-400"/>
                            {`${student_count} ${t('students')}`}
                        </div>
                    </div>
                    <div
                        style={{ padding: '4px 10px' }}
                        className={classNames(
                            `my-auto font-semibold text-xs italic rounded-full`,
                            _.find(CourseStates, {value: course_state})?.className
                        )}>
                        {t(_.find(CourseStates, {value: course_state})?.label)}
                    </div>
                </div>
            </div>
            {_.isFunction(renderContextMenu) && (
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}


export default Courses
